module.exports = __webpack_public_path__ + "static/media/IMAGE-2-PLASTIC-MULCH-desktop.3c62cf4c.jpg";